import React, { Component, PropTypes } from 'react';
import './SelectField.css';

const sfu = "select-field__ul";
const sfua = " select-field__ul--active";
const sa = "select__arrow";
const saa = " select__arrow--active";


class SelectField extends Component {
  constructor() {
    super();
    this.handleBlur = this.handleBlur.bind(this);
    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
		this.getInputStyles = this.getInputStyles.bind(this);
  }

  handleBlur() {
    const { handleBlur, parentName, position, field } = this.props;
    if (position !== null) {
  		window.setTimeout(() => {
      	handleBlur(field.name, position, parentName)
  		}, 100)
    } else {
  		window.setTimeout(() => {
      	handleBlur(field.name)
  		}, 100)
    }
  }

  handleOptionClick(value) {
    const { handleChange, parentName, position, field } = this.props;
    if (position !== null) {
      handleChange(value, field.name, position, parentName)
    } else {
      handleChange(value, field.name)
    }
  }

  handleDropdownClick() {
    const { handleFocus, handleClick, position, parentName, field } = this.props;
    if (position !== null) {
  		handleFocus(field.name, position, parentName);
      handleClick(field, position, parentName);
    } else {
  		handleFocus(field.name);
      handleClick(field);
    }
  }

	getInputStyles() {
    const { field } = this.props;
		let inputStyle = 'select-field__value ';
		let placeholderStyle = 'input__placeholder ';
		if (field.touched === true) {
			placeholderStyle = placeholderStyle + 'input__touched ';
		}
		if (field.error && field.hasBlurred) {
			placeholderStyle = placeholderStyle + 'input__placeholder-error';
			inputStyle = inputStyle + 'input__border-error';
		} else if (!field.error && field.touched) {
			placeholderStyle = placeholderStyle + 'input__placeholder-success';
			inputStyle = inputStyle + 'input__border-success';
		}
		return { placeholderStyle, inputStyle };
	}

  render() {
    const { field } = this.props;
		let fieldStyle = this.getInputStyles();
    return (
      <div>
        <div className="select-field__wrap">
          <input
            readOnly={true}
            onFocus={this.handleDropdownClick}
            className={fieldStyle.inputStyle}
            onBlur={this.handleBlur}
            value={field.displayValue} />
					<p className={fieldStyle.placeholderStyle}>
						{field.placeholder}
					</p>
          <img
            alt="alt"
            src="/images/downArrow.svg"
            className={field.isActive ? sa + saa : sa}/>
          <ul className={field.isActive ? sfu + sfua : sfu}>
            {
              field.options.map((option, index) => {
                return (
                  <li
                    onClick={() => this.handleOptionClick(option)}
                    key={index}
                    className="select-field">
                    {option.name}
                  </li>
                )
              })
            }
          </ul>
          {
            this.props.field.error && this.props.field.hasBlurred &&
            <p className="input-field__error">{this.props.field.error}</p>
          }
        </div>
      </div>
    );
  }
}

SelectField.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      error: PropTypes.string,
      placeholder: PropTypes.string.isRequired,
      hasBlurred: PropTypes.bool.isRequired,
      inputType: PropTypes.string.isRequired,
      breed: PropTypes.string.isRequired,
      options: PropTypes.array.isRequired,
      isActive: PropTypes.bool.isRequired
    }),
  handleClick: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired
};

export default SelectField;



/** WEBPACK FOOTER **
 ** ./src/components/SelectField/index.js
 **/